import state from './camstudyState';
import mutations from './camstudyMutations';
import getters from './camstudyGetters';
import actions from './camstudyActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
